'use client';

import { useStore } from 'zustand';

import { ProfileSheet } from './header-profile.sheet.component';

import { Button } from '@/components/ui/button/button.component';
import { authStore } from '@/store/auth.store';
import { modalsOpeningStore, setOpenSignInModal } from '@/store/modal';
import { SignInModal } from '@/app/(main)/_components/sign-in-modal/sign-in-modal.component';

export function NavbarProfile({
  isActiveStageOne,
}: {
  isActiveStageOne: boolean | string;
}) {
  const isLoggedIn = useStore(authStore, (state) => state.computed.isLoggedIn);
  const openSignInModal = useStore(
    modalsOpeningStore,
    (state) => state.signInModalIsOpen,
  );

  const handleSignIn = () => {
    setOpenSignInModal(true);
  };

  if (isActiveStageOne) {
    return null;
  }

  return (
    <>
      {!isLoggedIn
        ? (
            <>
              <Button
                onClick={handleSignIn}
                variant="secondary"
                color="primary"
                className="text-sm md:text-base h-8"
                data-testid="get-in-button"
              >
                Entrar
              </Button>
              <SignInModal
                isOpen={openSignInModal}
                setIsOpen={() => setOpenSignInModal(false)}
              />
            </>
          )
        : (
            <>
              <ProfileSheet />
            </>
          )}
    </>
  );
}
